module.exports = __webpack_public_path__ + "img/tags.1420cdf2.svg";